import { Pipe, PipeTransform } from '@angular/core';

@Pipe( { name: 'formattextinput' })

// Syntax -> Street: {{profiledetail.street | formattextinput:20 }}

export class getformattextpipe implements PipeTransform
{
    //**************************************************************
    transform( val, textlength)
        {
            //**************************************************************
            if ( textlength == undefined )
                {
                    return val;
                }
            //**************************************************************    
            var vallength = val.length

            if ( vallength > 20 )
                {
                    return val
                }
            else
                {
                    var addspace = "";

                    var nospace = textlength-vallength; 

                    for ( let i = 0; i < nospace; i++ )
                        {
                            addspace = addspace + "_"

                        }     

                    return val + addspace     

                }    
            //**************************************************************            
        }    
    //**************************************************************             
}